import React from 'react';
import { Tooltip } from 'antd';

const ExternalId = ({ t, externalId }) => {
  return (
    <>
      <span className="sync-status__label">
        {t('cms:cms.properties.homepage.property_management.external_id')}
      </span>
      <span className="sync-status__value sync-status__external-id">
        {externalId?.length > 10 ? (
          <Tooltip title={externalId}>
            <span>{`${externalId?.slice(0, 10)}...`}</span>
          </Tooltip>
        ) : (
          <>{externalId || '-'}</>
        )}
      </span>
    </>
  );
};

export default ExternalId;
